"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    fullHeight
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    basicFontSize,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const ccAudiencePickerSingleStudentsStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      const height = isMobileView ? pxToRem(48) : pxToRem(80);
      const paddingBottom = isMobileView ? 0 : pxToRem(20);
      return {
        height,
        paddingBottom
      };
    };
    const searchDeviceProps = () => {
      const paddingTop = isMobileView ? pxToRem(8) : pxToRem(20);
      const height = isMobileView ? pxToRem(64) : pxToRem(68);
      return {
        paddingTop,
        height
      };
    };
    const ccAudiencePickerFullItem = (0, _css.css)({
      height: isMobileView ? '100%' : fullHeight ? getMeasurement(fullHeight) : 'auto',
      display: 'flex',
      flexDirection: 'column'
    });
    const ccAudiencePickerSingleStudentsTitle = (0, _css.css)({
      fontSize: pxToRem(26),
      color: themeColors?.primary.dark,
      margin: 0,
      marginBottom: pxToRem(5),
      lineHeight: 1.05
    });
    const ccAudiencePickerSingleStudents = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: pxToRem(3)
    });
    const ccAudiencePickerSingleStudentsHeader = (0, _css.css)({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: pxToRem(16),
      gap: pxToRem(10),
      ...deviceProps()
    });
    const ccAudiencePickerSingleStudentsHeaderSelectTitle = (0, _css.css)({
      fontSize: basicFontSize,
      fontWeight: 'bold',
      paddingInlineStart: pxToRem(12),
      paddingBottom: pxToRem(8)
    });
    const ccAudiencePickerSingleStudentsHeaderSearch = (0, _css.css)({
      flexGrow: 1,
      ...searchDeviceProps()
    });
    return {
      ccAudiencePickerFullItem,
      ccAudiencePickerSingleStudents,
      ccAudiencePickerSingleStudentsTitle,
      ccAudiencePickerSingleStudentsHeader,
      ccAudiencePickerSingleStudentsHeaderSelectTitle,
      ccAudiencePickerSingleStudentsHeaderSearch
    };
  }, [basicFontSize, fullHeight, getMeasurement, isMobileView, pxToRem, themeColors?.primary.dark]);
  return {
    'cc-AudiencePicker__full-item': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerFullItem,
    'cc-AudiencePicker__single-students': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudents,
    'cc-AudiencePicker__single-students__title': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsTitle,
    'cc-AudiencePicker__single-students__header': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsHeader,
    'cc-AudiencePicker__single-students__header__select-title': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsHeaderSelectTitle,
    'cc-AudiencePicker__single-students__header__search': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsHeaderSearch
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;